<template>
	<div class="input-select" :class="{ 'is-disabled': disabled }">
		<VueSelect v-model="selectModel" class="style-chooser" :options="options" :loading="loading" label="label" ref="select">
			<template v-slot:option="option">
				<div class="select-option">
					<slot name="option" v-bind:option="option">
						<div>{{ option.label }}</div>
					</slot>
				</div>
			</template>

			<template v-slot:selected-option>
				<slot name="selected-option" v-bind:option="selectedOptionItem">
					{{ selectedOptionItem.label }}
				</slot>
			</template>
		</VueSelect>
	</div>
</template>

<script>
/*
This select receives as input 'options' in the form of { label: 'Height', value: 183 }
'label' is displayed in the select menu
'value' is the selection and is what 'selectedOption' is updated with.
*/

import VueSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
	name: 'InputSelect',
	components: {
		VueSelect,
	},
	props: {
		selectedOption: [Number, String],
		options: { type: Array, default: () => [] },
		loading: { type: Boolean, default: false },
		disabled: { type: Boolean },
	},
	computed: {
		selectModel: {
			set(option) {
				this.$emit('update:selectedOption', option.value);
			},
			get() {
				return this.selectedOption;
			},
		},
		selectedOptionItem() {
			return (
				this.options.find((opt) => {
					if (Object.prototype.hasOwnProperty.call(opt, 'id')) {
						return opt.id === this.selectModel;
					}
					if (Object.prototype.hasOwnProperty.call(opt, 'value')) {
						return opt.value === this.selectModel;
					}
					return false;
				}) || {}
			);
		},
	},
	methods: {
		close() {
			this.$refs.select.closeSearchOptions();
		},
	},
};
</script>

<style scoped lang="scss">
.input-select {
	&.is-disabled {
		pointer-events: none;

		::v-deep .vs__dropdown-toggle {
			background-color: var(--disabled-color);
			border-color: var(--disabled-color);
			color: #dfe2e8;

			.vs__selected {
				color: #dfe2e8;
			}
		}
	}

	&:hover {
		cursor: pointer;
	}

	::v-deep .v-select {
		background-color: var(--bg-color);
		color: var(--primary-text-color);

		.vs__selected,
		svg {
			color: var(--primary-text-color);
		}

		.vs__clear {
			display: none;
		}

		.vs__dropdown-toggle {
			border: var(--primary-border);
			border-radius: var(--border-radius);
		}

		ul {
			$menu-w: 100%;
			width: $menu-w;
			max-width: $menu-w;
			min-width: $menu-w;
			padding: 0;
			border: 0;
			border-radius: 4px;
			z-index: 99999;

			li.vs__dropdown-option {
				width: $menu-w;
				max-width: $menu-w;
				padding: 8px 4px;
				background-color: var(--bg-color);
				color: var(--primary-text-color);
				z-index: 99999;

				&:hover {
					filter: brightness(85%);
				}
			}
		}

		.vs__search {
			height: 28px;
			color: white;
		}

		.vs__spinner {
			border-radius: 50px;
			background: #9292929e;
			box-shadow: 0px 0px 11px #9292929e;
			border-left-color: #ffffff94;
		}
	}
	::v-deep .v-menu__content,
	::v-deep .v-list.v-select-list {
		max-height: 140px !important;
		overflow-x: hidden !important;
	}
}
</style>
